/**
 * POM-6534 — the words in the Change NDC & Lot "Before → After" strip.
 *
 * Before is what the row records, which is what its label prints now; After is what Apply would
 * send. Dates use the dialog's own YYYY-MM-DD form.
 */

import SYSTEM_DEFICIT from 'common/constants/inventoryLabels';
import { formatQty, shortfallAgainstFill, toDateOnly } from './bulkLotNdcStatus';

const NONE = 'none';

const recordedLotNote = ({ lot, todayStr }) => {
  if (lot.isManualEntry) return 'hand-recorded';
  if (lot.existsInInventory === false) return 'no longer in inventory';

  const expiresOn = toDateOnly(lot.expirationDate);
  if (!expiresOn) return '';

  return expiresOn < todayStr ? `expired ${expiresOn}` : `exp ${expiresOn}`;
};

export const describeRecordedLabel = ({ item, todayStr }) => {
  const recordedLots = item?.recordedLots ?? [];

  return {
    ndc: item?.effectiveNdc || NONE,
    lot: recordedLots.length ? recordedLots.map((lot) => lot.lotNumber).join(', ') : NONE,
    note: recordedLots.length === 1 ? recordedLotNote({ lot: recordedLots[0], todayStr }) : '',
  };
};

/**
 * `allocation` is the one Apply sends; `stockLot` is the picked inventory lot it came from, or null
 * for a hand-recorded entry.
 */
export const describeLabelAfterApply = ({ ndc, allocation, stockLot, fillQuantity }) => {
  const deficit = SYSTEM_DEFICIT.toLowerCase();
  const expiresOn = toDateOnly(stockLot?.expirationDate);
  let note = expiresOn ? `exp ${expiresOn}` : '';
  let claimsDeficit = false;

  if (allocation.isManualEntry) {
    note = `hand-recorded · ${formatQty(allocation.quantity)} as ${deficit}`;
    claimsDeficit = true;
  } else if (shortfallAgainstFill({ lot: stockLot, fillQuantity }) > 0) {
    note = `${formatQty(stockLot.remainingQty)} from stock + ${formatQty(
      shortfallAgainstFill({ lot: stockLot, fillQuantity })
    )} as ${deficit}`;
    claimsDeficit = true;
  }

  return { ndc: ndc || NONE, lot: allocation.lotNumber, note, claimsDeficit };
};
